export default () => ({
  subscriptionModalOpen: false,

  openSubscription(variantId) {
    const updateVariantId = document.querySelector("[data-backin-stock-variant-id]")
    if (updateVariantId) updateVariantId.setAttribute("data-backin-stock-variant-id", variantId)
    this.subscriptionModalOpen = true
  },
  closeSubscription() {
    const updatevariant = document.querySelector("[data-backin-stock-variant-id]")
    if (updatevariant) updatevariant.removeAttribute("data-backin-stock-variant-id")
    this.subscriptionModalOpen = false
  }
})